import * as types from "../../constants/ApiConstant";

const initialState = {
  resources: []
};

export default function reducer(state = initialState, actions) {
  switch (actions.type) {
    case types.GET_RESOURCES_SUCCESS: {
      return {
        ...state,
        resources: actions.resources
      };
    }
    case types.POST_RESOURCES_SUCCESS: {
      return {
        ...state,
        resources: actions.resources
      };
    }
    default:
      return state;
  }
}